export const config = {
    // Site is served at the domain root (Docker local + VPS), not in a
    // /baseone subdirectory. Same-origin relative paths work everywhere:
    //   API:    domainRelPath + '/wp-json/...'  ->  '/wp-json/...'
    //   router: domainRelPathExt                ->  '/'
    domain: '',
    domainRelPath: '',
    domainRelPathExt: '/',
    pageIndex: {
        home:           0
    }
};
export default config;